<template>
  <div
    class="ts-relative ts-flex ts-w-full ts-flex-wrap ts-items-stretch ts-mb-3"
  >
    <input
        v-model.trim="model.text"
        type="text"
        placeholder="Search"
        class="ts-px-3 ts-py-3 ts-placeholder-blueGray-300 ts-text-blueGray-600 ts-relative ts-bg-white ts-rounded ts-text-sm ts-border-0 ts-shadow ts-outline-none focus:ts-outline-none focus:ts-ring ts-w-full ts-pr-10"
    />
    <span
      class="ts-z-10 ts-h-full ts-leading-snug ts-font-normal ts-absolute ts-text-center ts-text-blueGray-300 ts-bg-transparent ts-rounded ts-text-base ts-items-center ts-justify-center ts-w-8 ts-right-0 ts-pr-3 ts-py-3"
    >
      <i class="fas fa-search"></i>
    </span>
  </div>
</template>
<script>
export default {
    props: ['value'],
    data(){
        return{
            model: {
                text: ''
            }
        }
    },
    created(){
        this.model = this.value
    }
}
</script>